// extracted by mini-css-extract-plugin
module.exports = {"image":"TopSec_image__3Onw8"};